// run immediately
(function() {
  const path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
  const query = window.location.search || '';
  const hash = window.location.hash || '';
  
  if (path === '/collections') {
    window.location.replace('/collections/all' + query + hash);
  } else if (path === '/products/donation') {
    window.location.replace('/pages/donate' + query + hash);
  }
})();

// run after the elements have loaded
document.addEventListener("DOMContentLoaded", (event) => {
  // You can add any DOM-ready code here if needed
});

// edit form styles
document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector('#app-embed');

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();
      sheet.insertRule(`
        h2 {
          color: #000 !important;
          font-size: 64px !important;
          line-height: 1.2 !important;
          padding: 75px 0 0 !important;
          margin: 0 !important;
        }
      `);

      shadow.adoptedStyleSheets.push(sheet);

      if (formContainer) {
        formContainer.classList.add('loaded');
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});